import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuthToken } from './lib/authToken';
import { Login } from './pages/Login';
import {
  AccountsPage,
  AdminPage,
  AuditPage,
  DashboardPage,
  OrdersPage,
  QueuePage,
  WorkOrderDetailPage,
  WorkOrderFormPage,
} from './zen/ZenPages';
import { PortalPage } from './zen/PortalPage';
import { ZenAccessRoute, ZenLandingRoute, ZenProtectedRoute, ZenShell } from './zen/ZenShell';

function LoginRoute() {
  const token = useAuthToken();
  return token ? <Navigate to="/" replace /> : <Login />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/portal" element={<PortalPage />} />
      <Route element={<ZenProtectedRoute />}>
        <Route element={<ZenShell />}>
          <Route index element={<ZenLandingRoute />} />
          <Route path="dashboard" element={<ZenAccessRoute capability="dashboard"><DashboardPage /></ZenAccessRoute>} />
          <Route path="queue" element={<ZenAccessRoute capability="queue"><QueuePage /></ZenAccessRoute>} />
          <Route path="queue/logistics" element={<ZenAccessRoute capability="queue"><QueuePage departmentId="dept-delivery" /></ZenAccessRoute>} />
          <Route path="queue/delivery" element={<Navigate to="/queue/logistics" replace />} />
          <Route path="queue/installation" element={<Navigate to="/queue/logistics" replace />} />
          <Route path="queue/transportation" element={<Navigate to="/queue/logistics" replace />} />
          <Route path="completed" element={<ZenAccessRoute capability="queue"><QueuePage completed /></ZenAccessRoute>} />
          <Route path="work-orders" element={<ZenAccessRoute capability="orders"><OrdersPage /></ZenAccessRoute>} />
          <Route path="work-orders/completed" element={<ZenAccessRoute capability="orders"><OrdersPage view="completed" /></ZenAccessRoute>} />
          <Route path="work-orders/deleted" element={<ZenAccessRoute capability="admin"><OrdersPage view="deleted" /></ZenAccessRoute>} />
          <Route path="work-orders/new" element={<ZenAccessRoute capability="create-order"><WorkOrderFormPage /></ZenAccessRoute>} />
          <Route path="work-orders/:id" element={<ZenAccessRoute capability="orders"><WorkOrderDetailPage /></ZenAccessRoute>} />
          <Route path="work-orders/:id/edit" element={<ZenAccessRoute capability="orders"><WorkOrderFormPage /></ZenAccessRoute>} />
          <Route path="accounts" element={<ZenAccessRoute capability="ledger"><AccountsPage /></ZenAccessRoute>} />
          <Route path="accounts/:clientId" element={<ZenAccessRoute capability="ledger"><AccountsPage /></ZenAccessRoute>} />
          <Route path="admin" element={<ZenAccessRoute capability="admin"><AdminPage /></ZenAccessRoute>} />
          <Route path="audit" element={<ZenAccessRoute capability="admin"><AuditPage /></ZenAccessRoute>} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
